import type { PickemDto } from '@/api/backoffice-schemas';
import { MatchStatusType } from '@/constants/match.const';
import { getWinningTeamId } from '@/utils/pickems';

export const BettablePickemsStatus = ({
  pickems,
}: {
  pickems: PickemDto[];
}) => {
  const bettedPickems = pickems.filter((pickem) => pickem.isBetPlaced);

  if (bettedPickems.length === 0) {
    return null;
  }

  const wonPickems = pickems.filter(
    (pickem) =>
      pickem.winnerChoiceId === getWinningTeamId(pickem.match) &&
      pickem?.match?.status === MatchStatusType.FINISHED
  );

  const notWonPickems = pickems.filter(
    (pickem) =>
      pickem.winnerChoiceId !== getWinningTeamId(pickem.match) &&
      pickem?.match?.status === MatchStatusType.FINISHED
  );

  const finishedPickems = wonPickems.length + notWonPickems.length;

  const allMatchesFinished =
    finishedPickems === bettedPickems.length && bettedPickems.length > 0;

  const getStatusColor = () => {
    if (bettedPickems.length === 0) {
      return 'text-gray-400';
    }
    if (!allMatchesFinished) {
      return 'text-orange';
    }
    return wonPickems.length > notWonPickems.length
      ? 'text-green-500'
      : 'text-red-500';
  };

  return (
    <div className="mb-4 flex items-center justify-end">
      <div className="flex flex-col items-center gap-1 rounded-lg bg-card-bg px-4 py-2 text-sm">
        <span className="font-semibold">Correct Picks</span>
        <div className="flex items-center gap-1">
          <span className={`font-semibold ${getStatusColor()}`}>
            {wonPickems.length}
          </span>
          <span className="text-gray-400">/</span>
          <span className="font-semibold text-gray-400">
            {bettedPickems.length}
          </span>
        </div>
      </div>
    </div>
  );
};
